import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-467" />, document.getElementById("root"));
index.tsx;